import { TnALocationCodeDTO } from "../../models/tna-location-codes/tna-location-code-dto";
import { TnALocationCodeFilter } from "../../models/tna-location-codes/tna-location-code-filter";
import { TnALocationCodeSTO } from "../../models/tna-location-codes/tna-location-code-sto";
import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { BaseApiService } from "../base";

export class TnALocationCodesApiService extends BaseApiService<TnALocationCodeDTO, TnALocationCodeSTO> {
  constructor() {
    super({
      servicePath: "/TnALocationCode",
      loadItemsPath: "/GetTnALocationCode",
      saveItemsPath: "/SaveTnALocationCode",
    });
  }
}

export const loadClockingLocationCodes = async (propsFilter?: TnALocationCodeFilter, signal?: AbortSignal) => {
  const apiService = new TnALocationCodesApiService();
  const response = await apiService.loadItems(
    propsFilter,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    signal
  );

  toastifyResponse(response, "failed");

  return response;
};
